import { render, staticRenderFns } from "./FacebookPostMatchDetails.vue?vue&type=template&id=73d53b9e&scoped=true&"
import script from "./FacebookPostMatchDetails.vue?vue&type=script&lang=js&"
export * from "./FacebookPostMatchDetails.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPostMatchDetails.vue?vue&type=style&index=0&id=73d53b9e&prod&lang=css&"
import style1 from "./FacebookPostMatchDetails.vue?vue&type=style&index=1&id=73d53b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d53b9e",
  null
  
)

export default component.exports